export default "/assets/images/accessory-img-03.f9c60db82418c39d.jpg";